var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('vb-icon',{staticClass:"not-found__icon",attrs:{"name":'exclamation',"color":_vm.sass('primary'),"size":40}}),_c('div',{staticClass:"not-found__text"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }